import { useMutation } from '@apollo/client';
import StoreConfig from '@/config';
import { useCallback } from 'react';
import { useCartContext } from '@/context/cart';
import { useUserContext } from '@/context/user';
import { BrowserPersistence } from '@/util';
import { useCartTrigger } from '@/hooks/Header/useCartTrigger';
import { GET_ITEM_COUNT_QUERY } from '@/components/Header/cartTrigger.gql';
import DEFAULT_OPERATIONS from '@/components/CreateAccount/createAccount.gql';

const storage = new BrowserPersistence();

export const useFooter = (props = {}) => {
  const { itemCount } = useCartTrigger({
    queries: {
      getItemCountQuery: GET_ITEM_COUNT_QUERY,
    },
  });

  const { createCartMutation } = DEFAULT_OPERATIONS;

  const [fetchCartId] = useMutation(createCartMutation);

  const [{ cartId }, { getCartDetails, createCart, removeCart }] = useCartContext();

  const [{ isSignedIn }, { getUserDetails, setToken }] = useUserContext();

  const availableCountries = StoreConfig.available_countries;

  const currentCountryCode = StoreConfig.current_country_code;

  const handleSwitchCountry = useCallback(
    async countryCode => {
      const targetCountry = availableCountries.find(temp => temp.code === countryCode);

      const currentCountry = availableCountries.find(temp => temp.code === currentCountryCode);

      const signin_token = storage.getItem('signin_token');

      if (isSignedIn) {
        // 已登录

        const currentUrl = window.location.href;
        const url = new URL(currentUrl);

        // 获取当前的查询参数
        const queryParams = new URLSearchParams(url.search);

        queryParams.set('from_country', currentCountryCode);
        queryParams.set('token', signin_token);

        if (itemCount > 0) {
          // 购物车不为空
          queryParams.set('cart_id', cartId);
          // 清空购物车

          await removeCart();

          await createCart({
            fetchCartId,
          });
        }

        // 更新 URL 的查询参数
        url.search = queryParams.toString();

        const targetUrl = url.toString().replace(currentCountry.url, targetCountry.url);

        window.location.href = targetUrl;
      } else {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);

        // 获取当前的查询参数
        const queryParams = new URLSearchParams(url.search);

        queryParams.set('from_country', currentCountryCode);

        if (itemCount > 0) {
          // 购物车不为空
          queryParams.set('cart_id', cartId);

          // 清空购物车
          await removeCart();

          await createCart({
            fetchCartId,
          });
        }

        // 更新 URL 的查询参数
        url.search = queryParams.toString();

        const targetUrl = url.toString().replace(currentCountry.url, targetCountry.url);

        window.location.href = targetUrl;
      }
    },
    [availableCountries, isSignedIn, currentCountryCode, itemCount, cartId, removeCart, createCart, fetchCartId],
  );

  return {
    handleSwitchCountry,
  };
};
